import http from './public'

export default {
    // 获取订单列表
    getOrderList: (params) => {
        return http.fetchGet('orderList', params)
    },
    // 获取订单列表
    getOrder: (params) => {
        return http.fetchGet('order', params)
    },
    // 取消订单
    updateOrder: (orderId,params) => {
        return http.fetchPost('orderUpdate?out_trade_no='+orderId, params)
    },
    // 订单微信支付
    wxpay: (params) => {
        return http.fetchPost('wxpay', params)
    },
}